module.exports = __webpack_public_path__ + "img/pub_plus_1.33726082.png";